import { render, staticRenderFns } from "./add-address.vue?vue&type=template&id=754777e2&scoped=true"
import script from "./add-address.vue?vue&type=script&lang=ts"
export * from "./add-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754777e2",
  null
  
)

export default component.exports